<template>
  <div class="bonusSetting">
    <el-tabs class="bonusSetting-tabs" v-model="activeNameChildValue" type="card" @tab-click="handleClick">
      <el-tab-pane :label="item.versionNameSub" :name="index+''" v-for="(item, index) in subVersionList" :key="index+''">
        <el-form :model="bonusSetting" ref="bonusSettingRef">
          <!-- <el-form-item label="">
            <div class="bonusSetting_title">封顶设定</div>
            <span>{{a}}</span>
            <el-input class="bonusSetting_input" v-model="bonusSetting.value"></el-input>
          </el-form-item> -->
          <!-- <el-divider></el-divider> -->
          <el-form-item label="" v-for="(item, index) in bonusSetting" :key="index">
            <div class="bonusSetting_title" v-if="index == 0">职位门槛</div>
            <el-input class="bonusSetting_input_left" v-model="item.maxScore" placeholder="请填写封顶设定"></el-input>
            <el-select class="bonusSetting_select" v-model="item.kpi" @change="((value)=>{changeKpi(value, index)})" @focus="focusKpi" placeholder="请选择KPI">
              <el-option v-for="item in kpiList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select class="bonusSetting_select_center" v-model="item.operator" placeholder="运算符">
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="=" value="="></el-option>
            </el-select>
            <el-input class="bonusSetting_input" v-model="item.value" placeholder="请填写标准"></el-input>
            <el-input class="bonusSetting_input" v-model="item.coffient" placeholder="请填写结果"></el-input>
            <el-select class="bonusSetting_select_more" v-model="item.positions" @change="((value)=>{changePositions(value, index)})" @focus="focusPositions" multiple collapse-tags placeholder="请选择职位">
              <el-option v-for="item in positionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button type="button" v-if="index == 0" @click="addList(bonusSetting)">添加</el-button>
            <el-button v-if="index > 0" type="button" @click="deleteList(bonusSetting, index)">删除</el-button>
          </el-form-item>
          <!-- <el-divider></el-divider>
          <el-form-item label="" v-for="(item, index) in form.coefficient" :key="index">
            <div class="bonusSetting_title" v-if="index == 0">发放系数</div>
            <el-select class="bonusSetting_select" style="padding-right:10px" v-model="item.role" placeholder="Select" clearable>
              <el-option label="1" value="1"></el-option>
              <el-option label="2" value="2"></el-option>
              <el-option label="3" value="3"></el-option>
              <el-option label="4" value="4"></el-option>
            </el-select>
            <span style="padding:0 10px;width:100px">=</span>
            <el-input class="bonusSetting_input" v-model="item.value"></el-input>
            <el-button type="button" v-if="index == 0" @click="addList(form.coefficient)">添加</el-button>
            <el-button v-if="index > 0" type="button" @click="deleteList(form.coefficient, index)">删除</el-button>
          </el-form-item> -->
        </el-form>
        <el-col class="bonusSetting_button" :span="24">
          <el-button size="small" @click="cancel()">清除</el-button>
          <el-button type="primary" size="small" @click="deleting()">删除</el-button>
          <el-button type="primary" size="small" @click="confirm()">保存</el-button>
        </el-col>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'bonusSetting',
  props: ['activeNameChild'],
  data () {
    return {
      activeNameChildValue: '',
      subVersionList: [], // 季度列表
      bonusSetting: [
        {
          maxScore: '',
          kpi: '',
          operator: '',
          value: '',
          coffient: '',
          positions: []
        }
      ],
      kpiList: [],
      positionList: [],
      versionNameSub: '',
      channelId: '',
      year: '',
      a: '<='
    }
  },
  watch: {
    // 监听tabs-index值改变
    activeNameChild (newValue, oldValue) {
      this.activeNameChildValue = newValue
    }
  },
  methods: {
    // 季度列表--2021-医院
    getQuarterBonusList (versionName) {
      this.bonusSetting = []
      this.$http.get(this.API.versionInfoSub, { params: { pVersionName: versionName } }).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.subVersionList = data.data
          // console.log(data.data)
          // 门槛调整--2021-医院-Q1--待处理
          this.getBonusSetting(data.data[0].versionNameSub)
          this.versionNameSub = data.data[0].versionNameSub
          this.channelId = data.data[0].channelId
          this.year = data.data[0].year
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 查询
    getBonusSetting (versionNameSub) {
      this.bonusSetting = this.templateData()
      this.$http.post(this.API.bonusSettingQuery, { versionNameSub: versionNameSub }).then((res) => {
        let data = res.data
        if (data.code === 200) {
          if (data.data.length > 0) {
            this.bonusSetting = data.data
          } else {
            this.bonusSetting = this.templateData()
          }
          // console.log(data.data)
          // console.log(this.bonusSetting)
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 切换上传状态
    handleClick (tab, event) {
      // console.log(tab)
      this.$emit('activeNameChildChange', tab.name)
      this.versionNameSub = tab.label
      // 门槛调整--2021-医院-Q1--待处理
      this.getBonusSetting(tab.label)
    },
    changeKpi (v, i) {
      // console.log(v)
      // console.log(i)
      this.bonusSetting[i].kpi = v
      // console.log(this.bonusSetting)
    },
    focusKpi (v) {
      this.kpiList = []
      this.$http.get(this.API.kpiQueryByChannelId, { params: { channelId: this.channelId, year: this.year } }).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200 && data.data.length > 0) {
          let arr = data.data
          let kpiList = []
          // let arr1 = arr.filter(ele => {
          //   return ele.kpiType === '季度考核'
          // })
          arr.forEach(ele => {
            kpiList.push({
              label: ele.kpiNm,
              value: ele.kpiNm
            })
          })
          this.kpiList = kpiList
          // this.$message.success('搜索成功！')
        } else if (data.data.length === 0 || data.data === null) {
          this.$message.warning('暂无数据！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    changePositions (v, i) {
      // console.log(v)
      // console.log(i)
      // this.bonusSetting[i].positions = []
      this.bonusSetting[i].positions = v
      // console.log(this.bonusSetting)
    },
    focusPositions (v) {
      this.positionList = []
      this.$http.get(this.API.positionListByChannelId, { params: { channelId: this.channelId } }).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200 && data.data.length > 0) {
          let arr = data.data
          let positionList = []
          arr.forEach(ele => {
            positionList.push({
              label: ele.name,
              value: ele.name
            })
          })
          this.positionList = positionList
          // this.$message.success('搜索成功！')
        } else if (data.data.length === 0 || data.data === null) {
          this.$message.warning('暂无数据！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 取消
    cancel () {
      this.bonusSetting = this.templateData()
    },
    // 删除
    deleting () {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(this.API.bonusSettingDelete, { versionNameSub: this.versionNameSub }).then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('删除成功！')
            this.bonusSetting = this.templateData()
            // this.getBonusSetting(tab.label)
          } else {
            this.$message.error('接口调用失败！')
          }
        })
      }).catch(() => {
        this.$message.warning('已取消删除！')
      })
    },
    // 保存
    confirm () {
      let bonusSetting = this.bonusSetting
      bonusSetting.forEach(ele => {
        ele.versionNameSub = this.versionNameSub
      })
      this.$http.post(this.API.bonusSettingSave, bonusSetting).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.getBonusSetting(this.versionNameSub)
          this.$message.success('保存成功！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    addList (item) {
      item.push({
        maxScore: '',
        kpi: '',
        operator: '',
        value: '',
        coffient: '',
        positions: []
      })
    },
    deleteList (item, index) {
      item.splice(index, 1)
    },
    templateData () {
      return [
        {
          maxScore: '',
          kpi: '',
          operator: '',
          value: '',
          coffient: '',
          positions: []
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.bonusSetting {
  .bonusSetting-tabs {
    .bonusSetting_title {
      width: 120px;
      font-size: 16px;
      font-weight: bold;
    }
    .bonusSetting_input {
      padding:0 10px 0 10px;
      width:150px;
    }
    .bonusSetting_input_left {
      padding-right: 10px;
      width:150px;
    }
    .bonusSetting_select {
      padding: 0 10px
    }
    .bonusSetting_select_center {
      padding:0 10px;
      width:100px
    }
    .bonusSetting_select_more {
      padding:0 20px 0 10px;
      width:280px
    }
    .bonusSetting_button {
      text-align: right;
      margin: 10px 0
    }
    /deep/.el-tabs__item {
      border: none !important;
      border-right: 1px solid #eee !important;
    }
    /deep/.el-tabs__active-bar {
      height: 2px !important;
    }
    /deep/.el-tabs__item.is-active {
      background-color: #fff !important;
      color: #409eff !important;
      border-bottom-color: #fff;
    }
    /deep/.el-tabs__item.is-top:nth-child(2) {
      border-left: 1px solid #eee;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
      padding-left: 20px !important;
    }
    /deep/.el-tabs__item.is-top:last-child {
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      padding-right: 20px !important;
      border-right: none !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 2px !important;
    }
    /deep/.el-tabs__nav-scroll {
      text-align: left !important;
    }
    /deep/.el-tabs__nav {
      float: left !important;
    }
  }
}
</style>
